import { ITrocarSenhaUseCase } from "../../../presentation/useCases/update/trocar_senha_use_case";
import { IAuthRepository } from "../../repositories/auth_repository";

/**
 * TrocarSenhaUseCase
 */

export class TrocarSenhaUseCase implements ITrocarSenhaUseCase {
  constructor(private readonly repository: IAuthRepository) { }

  async trocarSenha(
    login: string,
    senhaAtual: string,
    novaSenha: string,
  ): Promise<void> {
    await this.repository.trocarSenha(
      login,
      senhaAtual,
      novaSenha,
    );
  }
}
